module.exports = __webpack_public_path__ + "img/no_liked_infographics.e7cd14ba.png";